export default "__VITE_ASSET__DF07Grs3__"